export const RESPONSE_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const TOURIST_ERROR_CODES = {
  TOURIST_NOT_FOUND: 'T0001',
  NOT_ALLOWED_VISA: 'T0002',
  NOT_ALLOWED_PASSPORT: 'T0003',
  INVALID_PASSPORT: 'T0004',
  DEPARTURE_NOT_FOUND: 'T0005',
  AIRPORT_IP_NOT_VALID: 'T0006',
  CHART_NUMBER_ALREADY_EXIST: 'T0007',
} as const;

export const TOURIST_ERROR_CODE_VALUES = Object.values(TOURIST_ERROR_CODES);

export const REFUND_ERROR_CODES = {
  REFUND_NOT_FOUND: 'R0001',
  REFUND_HOSPITAL_NOT_MATCHED: 'R0002',
  REFUND_CANCEL_EXCEPTION: 'R0003',
  RECORD_NOT_FOUND: 'R0004',
  TEMP_INFO_NOT_FOUND: 'R0005',
  REFUND_NOT_FOUND_BY_DEPARTURE_ID: 'R0006',
  REFUND_NOT_FOUND_BY_KIOSK_TRANSACTION_ID: 'R0007',
  KIOSK_REFUND_CANNOT_BE_CANCELLED: 'R0008',
  HOMETAX_RECORD_NOT_EXIST: 'R0009',
  REFUND_ALREADY_WITHDRAWN: 'R0010',
  SERIAL_NUMBER_GENERATE_FAIL: 'R0011',
  REFUND_ALREADY_REGISTERED_IN_RECORD: 'R0012',
  REFUND_CANNOT_BE_CANCELLED: 'R0014',
} as const;

export const REFUND_ERROR_CODE_VALUES = Object.values(REFUND_ERROR_CODES);

export const ERROR_LEVELS = {
  FATAL: 'fatal',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export const STORE_TOURIST_ERROR_CODES = {
  INVALID_PASSPORT: 'P0001',
  INVALID_PASSWORD: 'P0002',
  INVALID_BUSINESS_NUMBER: 'P0003',
  INVALID_NATION: 'P0004',
  ID_NOT_FOUND: 'P0005',
  CUSTOMER_NOT_FOUND: 'P0006',
  ALREADY_EXISTS: 'P0007',
  ALREADY_CANCELLED: 'P0008',
  INVALID_DEPARTURE: 'P0009',
  FEEDBACK_NOT_FOUND: 'P0010',
  FRANCHISEE_NOT_FOUND: 'P0011',
  ADVERTISEMENT_NOT_FOUND: 'P0012',
} as const;

export const STORE_TOURIST_ERROR_CODE_VALUES = Object.values(
  STORE_TOURIST_ERROR_CODES,
);

export const STORE_REFUND_ERROR_CODES = {
  REFUND_NOT_FOUND: 'R0001',
  ORDER_NOT_FOUND: 'R0002',
  KOR_CUSTOMER: 'R0003',
  CHECK_ITEM_PRICE: 'R0004',
  INVALID_EXTERNAL_REFUND_INDEX: 'R0005',
  CANCEL_IS_NOT_ALLOWED: 'R0006',
  REFUND_RECORD_NOT_FOUND: 'R0007',
  REFUND_IS_ALREADY_COMPLETE: 'R0008',
  REFUND_FAILED: 'R0009',
  ORDER_ALREADY_CANCELED: 'R0010',
  REFUND_ALREADY_REGISTERED: 'R0011',
  ORDER_ALREADY_MAP_TO_CUSTOMER: 'R0012',
  REFUND_ALREADY_REGISTERED_IN_RECORD: 'R0013',
};

export const STORE_REFUND_ERROR_CODE_VALUES = Object.values(
  STORE_REFUND_ERROR_CODES,
);

export const STORE_GLOBAL_ERROR_CODES = {
  UNKNOWN: 'G0001',
  INVALID_PARAMETER: 'G0002',
  DUPLICATE_REQUEST: 'G0003',
  WEBFLUX_GENERAL: 'G0004',
  MAIL_SEND_ERROR: 'G0005',
  OBJECT_STORAGE_UPLOAD_ERROR: 'G0006',
};

export const STORE_GLOBAL_ERROR_CODE_VALUES = Object.values(
  STORE_GLOBAL_ERROR_CODES,
);
